import { split, $007CNotEmpty$007C_$007C, $007CNullOrWhiteSpace$007C_$007C, toLower, $007CStartsWith$007C_$007C } from "./Shopfoo.Common/String.js";
import { BazaarCategory } from "./Shopfoo.Domain.Types/Catalog.js";
import { SearchConfig, CaseMatching, Highlighting, Column } from "./Search.js";
import { defaultArgWith, map, some } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { Union, Record } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { union_type, record_type, tuple_type, list_type, string_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { tail, head, isEmpty, tryPick, map as map_1, singleton, append, cons, sort, empty, ofArray } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { equals, compareArrays } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { join } from "./fable_modules/fable-library-js.4.24.0/String.js";
import { singleton as singleton_1, empty as empty_1, map as map_2, append as append_1, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { CategoryFilters, Filters__ToBooks, Filters__ToBazaar_Z3BF3079, Filters, SortDirection, FiltersModule_defaults, Filters_$reflection } from "./Filters.js";
import { Shopfoo_Domain_Types_Common_OLID__OLID_get_AsSKU, ISBN, Shopfoo_Domain_Types_Common_ISBN__ISBN_get_AsSKU, FSID, Shopfoo_Domain_Types_Common_FSID__FSID_get_AsSKU, OLID, SKU_$reflection } from "./Shopfoo.Domain.Types/Common.js";
import { RouterModule_trySeparateLast, RouterModule_encodeQueryString, RouterModule_nav, RouterModule_urlSegments, RouterModule_encodeParts } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { Route_$007CQuery$007C_$007C, Route_$007CInt$007C_$007C } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { Cmd_ofEffect } from "./fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";

function Shopfoo_Client_Search_CaseMatching__CaseMatching_get_Key(this$) {
    if (this$.tag === 1) {
        return undefined;
    }
    else {
        return "yes";
    }
}

function Shopfoo_Client_Search_Highlighting__Highlighting_get_Key(this$) {
    if (this$.tag === 0) {
        return undefined;
    }
    else {
        return "no";
    }
}

function Shopfoo_Domain_Types_Common_SKU__SKU_get_Key(this$) {
    const matchValue = this$.Type;
    const matchValue_1 = this$.Value;
    let matchResult, value;
    if (matchValue.tag === 0) {
        if ($007CStartsWith$007C_$007C("FS-", matchValue_1) != null) {
            matchResult = 0;
            value = matchValue_1;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return value;
        default: {
            let matchResult_1, value_1, value_2, value_3;
            switch (matchValue.tag) {
                case 0: {
                    matchResult_1 = 0;
                    value_1 = matchValue_1;
                    break;
                }
                case 1: {
                    matchResult_1 = 1;
                    value_2 = matchValue_1;
                    break;
                }
                case 2: {
                    if ($007CStartsWith$007C_$007C("OL", matchValue_1) != null) {
                        matchResult_1 = 2;
                        value_3 = matchValue_1;
                    }
                    else {
                        matchResult_1 = 3;
                    }
                    break;
                }
                default:
                    matchResult_1 = 3;
            }
            switch (matchResult_1) {
                case 0:
                    return `FS-${value_1}`;
                case 1:
                    return `BN-${value_2}`;
                case 2:
                    return value_3;
                default:
                    switch (matchValue.tag) {
                        case 2:
                            return `OL${matchValue_1}`;
                        case 3:
                            return "";
                        default:
                            throw new Error("Match failure: Shopfoo.Domain.Types.Common.SKUType");
                    }
            }
        }
    }
}

function Keys_BazaarCategory_key(_arg) {
    switch (_arg.tag) {
        case 1:
            return "electronics";
        case 2:
            return "jewelry";
        default:
            return "clothing";
    }
}

function Keys_BazaarCategory_tryFromKey(key) {
    const matchValue = key.toLowerCase();
    switch (matchValue) {
        case "clothing":
            return new BazaarCategory(0, []);
        case "electronics":
            return new BazaarCategory(1, []);
        case "jewelry":
            return new BazaarCategory(2, []);
        default:
            return undefined;
    }
}

function Keys_Column_key(_arg) {
    switch (_arg.tag) {
        case 1:
            return "sku";
        case 2:
            return "name";
        case 3:
            return "description";
        case 4:
            return "category";
        case 5:
            return "subtitle";
        case 6:
            return "authors";
        case 7:
            return "tags";
        default:
            return "num";
    }
}

function Keys_$007CCol$007C_$007C(key) {
    const matchValue = toLower(key);
    switch (matchValue) {
        case "num":
            return new Column(0, []);
        case "sku":
            return new Column(1, []);
        case "name":
            return new Column(2, []);
        case "description":
            return new Column(3, []);
        case "category":
            return new Column(4, []);
        case "subtitle":
            return new Column(5, []);
        case "authors":
            return new Column(6, []);
        case "tags":
            return new Column(7, []);
        default:
            return undefined;
    }
}

function Keys_SortBy_key(_arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    if (_arg[1].tag === 1) {
        return `${Keys_Column_key(_arg[0])}-desc`;
    }
    else {
        return Keys_Column_key(_arg[0]);
    }
}

function Keys_$007CDesc$007C_$007C(s) {
    if (toLower(s) === "desc") {
        return some(undefined);
    }
    else {
        return undefined;
    }
}

function Keys_$007CYesNo$007C_$007C(s) {
    const matchValue = toLower(s);
    switch (matchValue) {
        case "yes":
            return true;
        case "no":
            return false;
        default:
            return undefined;
    }
}

export class PageUrl extends Record {
    constructor(Segments, Query) {
        super();
        this.Segments = Segments;
        this.Query = Query;
    }
}

export function PageUrl_$reflection() {
    return record_type("Shopfoo.Client.Routing.PageUrl", [], PageUrl, () => [["Segments", list_type(string_type)], ["Query", list_type(tuple_type(string_type, string_type))]]);
}

export function PageUrl_WithSegments_Z35CD86D0(...segments) {
    return new PageUrl(ofArray(segments), empty());
}

export function PageUrl_get_Root() {
    return PageUrl_WithSegments_Z35CD86D0();
}

export function PageUrl__WithQueryParam_Z384F8060(this$, name, value) {
    return new PageUrl(this$.Segments, sort(cons([name, value], this$.Query), {
        Compare: compareArrays,
    }));
}

export function PageUrl__WithQueryParamNotEmpty_Z384F8060(this$, name, value) {
    if ($007CNullOrWhiteSpace$007C_$007C(value) != null) {
        return this$;
    }
    else {
        return PageUrl__WithQueryParam_Z384F8060(this$, name, value);
    }
}

export function PageUrl__WithQueryParamOptional_27AED5E3(this$, name, value) {
    if (value != null) {
        return PageUrl__WithQueryParamNotEmpty_Z384F8060(this$, name, value);
    }
    else {
        return this$;
    }
}

export function PageUrl__WithFiltersQueryParams_5CF160B0(this$, filters) {
    return PageUrl__WithQueryParamOptional_27AED5E3(PageUrl__WithQueryParamOptional_27AED5E3(PageUrl__WithQueryParamOptional_27AED5E3(PageUrl__WithQueryParamOptional_27AED5E3(this$, "search", filters.Search.Term), "highlight", Shopfoo_Client_Search_Highlighting__Highlighting_get_Key(filters.Search.Highlighting)), "matchCase", Shopfoo_Client_Search_CaseMatching__CaseMatching_get_Key(filters.Search.CaseMatching)), "sort", map((tupledArg) => Keys_SortBy_key(tupledArg[0], tupledArg[1]), filters.SortBy));
}

export function PageUrl__WithSegmentOptional_6DFDD678(this$, segment) {
    let matchResult, segment_1;
    if (segment != null) {
        if ($007CNotEmpty$007C_$007C(segment) != null) {
            matchResult = 0;
            segment_1 = segment;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return new PageUrl(append(this$.Segments, singleton(segment_1)), this$.Query);
        default:
            return this$;
    }
}

export function PageUrl__get_QueryString(this$) {
    return join("&", map_1((tupledArg) => (`${tupledArg[0]}=${tupledArg[1]}`), this$.Query));
}

export function PageUrl__get_SegmentsWithQueryString(this$) {
    return toList(delay(() => append_1(map_2((segment) => segment, this$.Segments), delay(() => {
        const matchValue = PageUrl__get_QueryString(this$);
        if ($007CNullOrWhiteSpace$007C_$007C(matchValue) != null) {
            return empty_1();
        }
        else {
            return singleton_1(`?${matchValue}`);
        }
    }))));
}

export class Page extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["About", "Admin", "Home", "Login", "NotFound", "ProductIndex", "ProductDetail"];
    }
}

export function Page_$reflection() {
    return union_type("Shopfoo.Client.Routing.Page", [], Page, () => [[], [], [], [], [["url", string_type]], [["filters", Filters_$reflection()]], [["Item", SKU_$reflection()]]]);
}

export function Page__get_Key(this$) {
    switch (this$.tag) {
        case 1:
            return "admin";
        case 2:
            return "home";
        case 3:
            return "login";
        case 4:
            return "not-found";
        case 5:
            if (this$.fields[0].CategoryFilters != null) {
                if (this$.fields[0].CategoryFilters.tag === 1) {
                    return "books";
                }
                else {
                    return "bazaar";
                }
            }
            else {
                return "products";
            }
        case 6:
            return `product-${Shopfoo_Domain_Types_Common_SKU__SKU_get_Key(this$.fields[0])}`;
        default:
            return "about";
    }
}

export function Page_CurrentNotFound() {
    return new Page(4, [RouterModule_encodeParts(RouterModule_urlSegments(window.location.hash, 1), 1)]);
}

export function Page_get_ProductIndexDefaults() {
    return new Page(5, [FiltersModule_defaults]);
}

export function Page_ProductIndexDefaultsWith_Z3D62F06A(changeFilters) {
    return new Page(5, [changeFilters(FiltersModule_defaults)]);
}

function Safe_Router_currentUrl(defaultValue) {
    try {
        return RouterModule_encodeParts(RouterModule_urlSegments(window.location.hash, 1), 1);
    }
    catch (matchValue) {
        return defaultValue;
    }
}

function Safe_Router_formatPath(segments) {
    try {
        return RouterModule_encodeParts(segments, 2);
    }
    catch (matchValue) {
        return join("/", segments);
    }
}

function Route_$007CDashed$007C(s) {
    return ofArray(split("-", s));
}

function Route_$007CParam$007C_$007C(key, queryParams) {
    return tryPick((tupledArg) => {
        if (equals(tupledArg[0], key)) {
            return some(tupledArg[1]);
        }
        else {
            return undefined;
        }
    }, queryParams);
}

function Route_$007CAuthor$007C(queryParams) {
    let matchResult, olid;
    const activePatternResult = Route_$007CParam$007C_$007C("author", queryParams);
    if (activePatternResult != null) {
        if ($007CNotEmpty$007C_$007C(activePatternResult) != null) {
            matchResult = 0;
            olid = activePatternResult;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return new OLID(olid);
        default:
            return undefined;
    }
}

function Route_$007CCategory$007C(queryParams) {
    const activePatternResult = Route_$007CParam$007C_$007C("category", queryParams);
    if (activePatternResult != null) {
        const storeCategoryKey = activePatternResult;
        return Keys_BazaarCategory_tryFromKey(storeCategoryKey);
    }
    else {
        return undefined;
    }
}

function Route_$007CHighlight$007C(queryParams) {
    let matchResult;
    const activePatternResult = Route_$007CParam$007C_$007C("highlight", queryParams);
    if (activePatternResult != null) {
        const activePatternResult_1 = Keys_$007CYesNo$007C_$007C(activePatternResult);
        if (activePatternResult_1 != null) {
            if (activePatternResult_1) {
                matchResult = 1;
            }
            else {
                matchResult = 0;
            }
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return new Highlighting(1, []);
        default:
            return new Highlighting(0, []);
    }
}

function Route_$007CMatchCase$007C(queryParams) {
    let matchResult;
    const activePatternResult = Route_$007CParam$007C_$007C("matchCase", queryParams);
    if (activePatternResult != null) {
        const activePatternResult_1 = Keys_$007CYesNo$007C_$007C(activePatternResult);
        if (activePatternResult_1 != null) {
            if (activePatternResult_1) {
                matchResult = 0;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return new CaseMatching(0, []);
        default:
            return new CaseMatching(1, []);
    }
}

function Route_$007CSearchTerm$007C(queryParams) {
    const activePatternResult = Route_$007CParam$007C_$007C("search", queryParams);
    if (activePatternResult != null) {
        const searchTerm = activePatternResult;
        return searchTerm;
    }
    else {
        return undefined;
    }
}

function Route_$007CSort$007C(queryParams) {
    let matchResult, col;
    const activePatternResult = Route_$007CParam$007C_$007C("sort", queryParams);
    if (activePatternResult != null) {
        const activePatternResult_1 = Route_$007CDashed$007C(activePatternResult);
        if (!isEmpty(activePatternResult_1)) {
            const activePatternResult_2 = Keys_$007CCol$007C_$007C(head(activePatternResult_1));
            if (activePatternResult_2 != null) {
                if (!isEmpty(tail(activePatternResult_1))) {
                    if (Keys_$007CDesc$007C_$007C(head(tail(activePatternResult_1))) != null) {
                        if (isEmpty(tail(tail(activePatternResult_1)))) {
                            matchResult = 0;
                            col = activePatternResult_2;
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return [col, new SortDirection(1, [])];
        default: {
            let matchResult_1, col_1;
            const activePatternResult_4 = Route_$007CParam$007C_$007C("sort", queryParams);
            if (activePatternResult_4 != null) {
                const activePatternResult_5 = Keys_$007CCol$007C_$007C(activePatternResult_4);
                if (activePatternResult_5 != null) {
                    matchResult_1 = 0;
                    col_1 = activePatternResult_5;
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0:
                    return [col_1, new SortDirection(0, [])];
                default:
                    return undefined;
            }
        }
    }
}

function Route_$007CFilters$007C(queryParams) {
    const activePatternResult = Route_$007CHighlight$007C(queryParams);
    const activePatternResult_1 = Route_$007CMatchCase$007C(queryParams);
    const activePatternResult_2 = Route_$007CSearchTerm$007C(queryParams);
    const activePatternResult_3 = Route_$007CSort$007C(queryParams);
    return (filters) => (new Filters(filters.CategoryFilters, new SearchConfig(filters.Search.Columns, activePatternResult_1, activePatternResult, activePatternResult_2), activePatternResult_3));
}

function Route_$007CSKU$007C_$007C(routeSegment) {
    let matchResult, fsid;
    const activePatternResult = Route_$007CDashed$007C(routeSegment);
    if (!isEmpty(activePatternResult)) {
        if (head(activePatternResult) === "FS") {
            if (!isEmpty(tail(activePatternResult))) {
                const activePatternResult_1 = Route_$007CInt$007C_$007C(head(tail(activePatternResult)));
                if (activePatternResult_1 != null) {
                    if (isEmpty(tail(tail(activePatternResult)))) {
                        matchResult = 0;
                        fsid = activePatternResult_1;
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return Shopfoo_Domain_Types_Common_FSID__FSID_get_AsSKU(new FSID(fsid));
        default: {
            let matchResult_1, isbn, olid;
            const activePatternResult_2 = Route_$007CDashed$007C(routeSegment);
            if (!isEmpty(activePatternResult_2)) {
                if (head(activePatternResult_2) === "BN") {
                    if (!isEmpty(tail(activePatternResult_2))) {
                        if (isEmpty(tail(tail(activePatternResult_2)))) {
                            matchResult_1 = 0;
                            isbn = head(tail(activePatternResult_2));
                        }
                        else if ($007CStartsWith$007C_$007C("OL", routeSegment) != null) {
                            matchResult_1 = 1;
                            olid = routeSegment;
                        }
                        else {
                            matchResult_1 = 2;
                        }
                    }
                    else if ($007CStartsWith$007C_$007C("OL", routeSegment) != null) {
                        matchResult_1 = 1;
                        olid = routeSegment;
                    }
                    else {
                        matchResult_1 = 2;
                    }
                }
                else if ($007CStartsWith$007C_$007C("OL", routeSegment) != null) {
                    matchResult_1 = 1;
                    olid = routeSegment;
                }
                else {
                    matchResult_1 = 2;
                }
            }
            else if ($007CStartsWith$007C_$007C("OL", routeSegment) != null) {
                matchResult_1 = 1;
                olid = routeSegment;
            }
            else {
                matchResult_1 = 2;
            }
            switch (matchResult_1) {
                case 0:
                    return Shopfoo_Domain_Types_Common_ISBN__ISBN_get_AsSKU(new ISBN(isbn));
                case 1:
                    return Shopfoo_Domain_Types_Common_OLID__OLID_get_AsSKU(new OLID(olid));
                default:
                    return undefined;
            }
        }
    }
}

function Route_$007CTag$007C(queryParams) {
    let matchResult, tag;
    const activePatternResult = Route_$007CParam$007C_$007C("tag", queryParams);
    if (activePatternResult != null) {
        if ($007CNotEmpty$007C_$007C(activePatternResult) != null) {
            matchResult = 0;
            tag = activePatternResult;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return tag;
        default:
            return undefined;
    }
}

export const PageModule_defaultPage = new Page(3, []);

export function PageModule_parseFromUrlSegments(segments) {
    let matchResult, url;
    if (!isEmpty(segments)) {
        switch (head(segments)) {
            case "about": {
                if (isEmpty(tail(segments))) {
                    matchResult = 1;
                }
                else {
                    matchResult = 6;
                }
                break;
            }
            case "admin": {
                if (isEmpty(tail(segments))) {
                    matchResult = 2;
                }
                else {
                    matchResult = 6;
                }
                break;
            }
            case "login": {
                if (isEmpty(tail(segments))) {
                    matchResult = 3;
                }
                else {
                    matchResult = 6;
                }
                break;
            }
            case "notfound": {
                if (!isEmpty(tail(segments))) {
                    const activePatternResult = Route_$007CQuery$007C_$007C(head(tail(segments)));
                    if (activePatternResult != null) {
                        if (!isEmpty(activePatternResult)) {
                            if (head(activePatternResult)[0] === "url") {
                                if (isEmpty(tail(activePatternResult))) {
                                    if (isEmpty(tail(tail(segments)))) {
                                        matchResult = 5;
                                        url = head(activePatternResult)[1];
                                    }
                                    else {
                                        matchResult = 6;
                                    }
                                }
                                else {
                                    matchResult = 6;
                                }
                            }
                            else {
                                matchResult = 6;
                            }
                        }
                        else {
                            matchResult = 6;
                        }
                    }
                    else {
                        matchResult = 6;
                    }
                }
                else {
                    matchResult = 4;
                }
                break;
            }
            default:
                matchResult = 6;
        }
    }
    else {
        matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return new Page(2, []);
        case 1:
            return new Page(0, []);
        case 2:
            return new Page(1, []);
        case 3:
            return new Page(3, []);
        case 4:
            return new Page(4, [""]);
        case 5:
            return new Page(4, [url]);
        default: {
            let matchResult_1, sku;
            if (!isEmpty(segments)) {
                if (head(segments) === "bazaar") {
                    if (!isEmpty(tail(segments))) {
                        const activePatternResult_1 = Route_$007CSKU$007C_$007C(head(tail(segments)));
                        if (activePatternResult_1 != null) {
                            if (isEmpty(tail(tail(segments)))) {
                                matchResult_1 = 0;
                                sku = activePatternResult_1;
                            }
                            else {
                                matchResult_1 = 1;
                            }
                        }
                        else {
                            matchResult_1 = 1;
                        }
                    }
                    else {
                        matchResult_1 = 1;
                    }
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0:
                    return new Page(6, [sku]);
                default: {
                    let matchResult_2, sku_1;
                    if (!isEmpty(segments)) {
                        if (head(segments) === "books") {
                            if (!isEmpty(tail(segments))) {
                                const activePatternResult_2 = Route_$007CSKU$007C_$007C(head(tail(segments)));
                                if (activePatternResult_2 != null) {
                                    if (isEmpty(tail(tail(segments)))) {
                                        matchResult_2 = 0;
                                        sku_1 = activePatternResult_2;
                                    }
                                    else {
                                        matchResult_2 = 1;
                                    }
                                }
                                else {
                                    matchResult_2 = 1;
                                }
                            }
                            else {
                                matchResult_2 = 1;
                            }
                        }
                        else {
                            matchResult_2 = 1;
                        }
                    }
                    else {
                        matchResult_2 = 1;
                    }
                    switch (matchResult_2) {
                        case 0:
                            return new Page(6, [sku_1]);
                        default: {
                            let matchResult_3, category, changeFilters;
                            if (!isEmpty(segments)) {
                                switch (head(segments)) {
                                    case "products": {
                                        if (isEmpty(tail(segments))) {
                                            matchResult_3 = 0;
                                        }
                                        else {
                                            matchResult_3 = 4;
                                        }
                                        break;
                                    }
                                    case "bazaar": {
                                        if (!isEmpty(tail(segments))) {
                                            const activePatternResult_3 = Route_$007CQuery$007C_$007C(head(tail(segments)));
                                            if (activePatternResult_3 != null) {
                                                const activePatternResult_4 = Route_$007CFilters$007C(activePatternResult_3);
                                                const activePatternResult_5 = Route_$007CCategory$007C(activePatternResult_3);
                                                if (isEmpty(tail(tail(segments)))) {
                                                    matchResult_3 = 3;
                                                    category = activePatternResult_5;
                                                    changeFilters = activePatternResult_4;
                                                }
                                                else {
                                                    matchResult_3 = 4;
                                                }
                                            }
                                            else {
                                                matchResult_3 = 4;
                                            }
                                        }
                                        else {
                                            matchResult_3 = 1;
                                        }
                                        break;
                                    }
                                    case "books": {
                                        if (isEmpty(tail(segments))) {
                                            matchResult_3 = 2;
                                        }
                                        else {
                                            matchResult_3 = 4;
                                        }
                                        break;
                                    }
                                    default:
                                        matchResult_3 = 4;
                                }
                            }
                            else {
                                matchResult_3 = 4;
                            }
                            switch (matchResult_3) {
                                case 0:
                                    return Page_get_ProductIndexDefaults();
                                case 1:
                                    return Page_ProductIndexDefaultsWith_Z3D62F06A(Filters__ToBazaar_Z3BF3079);
                                case 2:
                                    return Page_ProductIndexDefaultsWith_Z3D62F06A(Filters__ToBooks);
                                case 3:
                                    return Page_ProductIndexDefaultsWith_Z3D62F06A((filters) => {
                                        const bind$0040 = changeFilters(filters);
                                        return new Filters(new CategoryFilters(0, [category]), bind$0040.Search, bind$0040.SortBy);
                                    });
                                default: {
                                    let matchResult_4, authorId, changeFilters_1, tag;
                                    if (!isEmpty(segments)) {
                                        if (head(segments) === "books") {
                                            if (!isEmpty(tail(segments))) {
                                                const activePatternResult_6 = Route_$007CQuery$007C_$007C(head(tail(segments)));
                                                if (activePatternResult_6 != null) {
                                                    const activePatternResult_7 = Route_$007CFilters$007C(activePatternResult_6);
                                                    const activePatternResult_8 = Route_$007CAuthor$007C(activePatternResult_6);
                                                    const activePatternResult_9 = Route_$007CTag$007C(activePatternResult_6);
                                                    if (isEmpty(tail(tail(segments)))) {
                                                        matchResult_4 = 0;
                                                        authorId = activePatternResult_8;
                                                        changeFilters_1 = activePatternResult_7;
                                                        tag = activePatternResult_9;
                                                    }
                                                    else {
                                                        matchResult_4 = 1;
                                                    }
                                                }
                                                else {
                                                    matchResult_4 = 1;
                                                }
                                            }
                                            else {
                                                matchResult_4 = 1;
                                            }
                                        }
                                        else {
                                            matchResult_4 = 1;
                                        }
                                    }
                                    else {
                                        matchResult_4 = 1;
                                    }
                                    switch (matchResult_4) {
                                        case 0:
                                            return Page_ProductIndexDefaultsWith_Z3D62F06A((filters_1) => {
                                                const bind$0040_1 = changeFilters_1(filters_1);
                                                return new Filters(new CategoryFilters(1, [authorId, tag]), bind$0040_1.Search, bind$0040_1.SortBy);
                                            });
                                        default:
                                            return new Page(4, [Safe_Router_formatPath(segments)]);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

export function $007CPageUrl$007C(_arg) {
    switch (_arg.tag) {
        case 1:
            return PageUrl_WithSegments_Z35CD86D0("admin");
        case 2:
            return PageUrl_get_Root();
        case 3:
            return PageUrl_WithSegments_Z35CD86D0("login");
        case 4:
            return PageUrl__WithQueryParamNotEmpty_Z384F8060(PageUrl_WithSegments_Z35CD86D0("notfound"), "url", _arg.fields[0]);
        case 6:
            switch (_arg.fields[0].Type.tag) {
                case 1:
                    return PageUrl_WithSegments_Z35CD86D0("books", Shopfoo_Domain_Types_Common_SKU__SKU_get_Key(_arg.fields[0]));
                case 2:
                    return PageUrl_WithSegments_Z35CD86D0("books", Shopfoo_Domain_Types_Common_SKU__SKU_get_Key(_arg.fields[0]));
                case 3:
                    return PageUrl__WithQueryParam_Z384F8060(PageUrl_WithSegments_Z35CD86D0("notfound"), "url", Safe_Router_currentUrl("unknown"));
                default:
                    return PageUrl_WithSegments_Z35CD86D0("bazaar", Shopfoo_Domain_Types_Common_SKU__SKU_get_Key(_arg.fields[0]));
            }
        case 5:
            if (_arg.fields[0].CategoryFilters != null) {
                if (_arg.fields[0].CategoryFilters.tag === 1) {
                    const authorId = _arg.fields[0].CategoryFilters.fields[0];
                    const tag = _arg.fields[0].CategoryFilters.fields[1];
                    return PageUrl__WithFiltersQueryParams_5CF160B0(PageUrl__WithQueryParamOptional_27AED5E3(PageUrl__WithQueryParamOptional_27AED5E3(PageUrl_WithSegments_Z35CD86D0("books"), "author", map((_arg_2) => _arg_2.fields[0], authorId)), "tag", tag), _arg.fields[0]);
                }
                else {
                    const category = _arg.fields[0].CategoryFilters.fields[0];
                    return PageUrl__WithFiltersQueryParams_5CF160B0(PageUrl__WithQueryParamOptional_27AED5E3(PageUrl_WithSegments_Z35CD86D0("bazaar"), "category", map(Keys_BazaarCategory_key, category)), _arg.fields[0]);
                }
            }
            else {
                return PageUrl_WithSegments_Z35CD86D0("products");
            }
        default:
            return PageUrl_WithSegments_Z35CD86D0("about");
    }
}

export function Router_goToUrl(e) {
    e.preventDefault();
    RouterModule_nav(singleton(e.currentTarget.attributes.href.value), 1, 2);
}

export function Router_navigatePage(_arg) {
    const pageUrl = $007CPageUrl$007C(_arg);
    const queryString = pageUrl.Query;
    defaultArgWith(map((tupledArg) => {
        RouterModule_nav(append(tupledArg[0], singleton(tupledArg[1] + RouterModule_encodeQueryString(queryString))), 1, 2);
    }, RouterModule_trySeparateLast(pageUrl.Segments)), () => {
        RouterModule_nav(singleton(RouterModule_encodeQueryString(queryString)), 1, 2);
    });
}

export function Cmd_navigatePage(_arg) {
    const pageUrl = $007CPageUrl$007C(_arg);
    return Cmd_ofEffect((_arg_1) => {
        const queryString_1 = pageUrl.Query;
        defaultArgWith(map((tupledArg) => {
            RouterModule_nav(append(tupledArg[0], singleton(tupledArg[1] + RouterModule_encodeQueryString(queryString_1))), 1, 2);
        }, RouterModule_trySeparateLast(pageUrl.Segments)), () => {
            RouterModule_nav(singleton(RouterModule_encodeQueryString(queryString_1)), 1, 2);
        });
    });
}

